var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"edit-button no-print",class:[
          _vm.inputIsEditable
            ? 'edit-button-is-editable'
            : 'edit-button-is-not-editable',
          _vm.disabled ? 'edit-button-disabled' : ''
        ],attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.inputIsEditable ? "保存" : "编辑")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }